import _ from 'lodash'
import { FETCH_PRODUCT_SHQ_SHIPPING_BOXES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PRODUCT_SHQ_SHIPPING_BOXES:
      return action.payload
    default:
      return state
  }
}
